'use client';

import { BackButton } from '@/components/buttons/Buttons';
import { useNavigate } from 'react-router-dom';
import PaymentMethodTable from '../components/tables/PaymentMethodTable';
import styles from './payment-method-screen.module.css';

export default function PaymentMethodScreen() {
	const navigate = useNavigate();

	return (
		<div>
			<BackButton
				id="payment-method-back"
				label="Back"
				withIcon
				onClick={() => navigate(-1)}
			/>
			<h1 className={styles.pageTitle}>Payment Method</h1>
			<PaymentMethodTable />
		</div>
	);
}
